var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.0522,
    r: 16,
    fill: "#E60023"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0004 10.0522C12.6869 10.0522 10 12.7384 10 16.0526C10 18.5088 11.4775 20.6199 13.5922 21.5477C13.5752 21.1293 13.5893 20.6255 13.6959 20.1697C13.8116 19.6829 14.4678 16.9007 14.4678 16.9007C14.4678 16.9007 14.2766 16.5176 14.2766 15.951C14.2766 15.062 14.7924 14.398 15.4338 14.398C15.9792 14.398 16.2431 14.8079 16.2431 15.299C16.2431 15.8473 15.8931 16.6679 15.7132 17.4278C15.5629 18.0649 16.0321 18.5836 16.6601 18.5836C17.7968 18.5836 18.5624 17.1237 18.5624 15.3936C18.5624 14.0791 17.6768 13.0948 16.066 13.0948C14.2462 13.0948 13.1124 14.4516 13.1124 15.9672C13.1124 16.4908 13.2662 16.8591 13.5075 17.1441C13.619 17.2761 13.6338 17.3283 13.5936 17.4793C13.5654 17.5887 13.499 17.8554 13.4715 17.9605C13.4313 18.1122 13.3085 18.1673 13.1716 18.1108C12.3327 17.7686 11.9425 16.8506 11.9425 15.8183C11.9425 14.1143 13.3798 12.0695 16.2304 12.0695C18.5214 12.0695 20.0293 13.7284 20.0293 15.5072C20.0293 17.861 18.7211 19.6194 16.7913 19.6194C16.1443 19.6194 15.5347 19.2694 15.3258 18.8721C15.3258 18.8721 14.9772 20.2544 14.9039 20.5211C14.7769 20.9833 14.5278 21.4461 14.2999 21.806C14.8397 21.9655 15.4098 22.0522 16.0004 22.0522C19.3138 22.0522 22 19.3661 22 16.0526C22 12.7384 19.3138 10.0522 16.0004 10.0522Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(10 10.0522)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialPin);
export default __webpack_public_path__ + "static/media/social-pin.1de8d915beb204833c3b700cc654649b.svg";
export { ForwardRef as ReactComponent };